import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import camelCase from 'lodash-es/camelCase';
import { Generator } from '../topic-widgets/generator';
import css from '@holmescorp/book-widgets/css/topicpage.m.css';
const factory = create({ theme }).properties();
export const Xref = factory(({ properties, middleware: { theme } }) => {
    const { topicdata, additionalClasses = [] } = properties();
    const themeCss = theme.classes(css);
    const { children = [], attributes = { href: '#' } } = topicdata;
    const { href = '#' } = attributes;
    let xreftext = ' ';
    if (children.length == 1) {
        const kid = children[0];
        if (typeof kid === 'string') {
            const output = kid;
            if (output.includes('_icons_')) {
                additionalClasses.push(camelCase(output));
            }
            else {
                xreftext = kid;
            }
        }
        else {
            xreftext = w(Generator, { skipTitle: false, insection: true, topic: topicdata });
        }
    }
    else if (children.length > 1) {
        xreftext = w(Generator, { skipTitle: false, insection: true, topic: topicdata });
    }
    else {
        xreftext = '--cross-reference--';
    }
    return v('a', { classes: [themeCss.xref, ...additionalClasses], href, target: '_blank' }, [xreftext]);
});
